<template>
    <LayoutsSectionCardTemplate>
        <template #title>
            {{ content.title }}
        </template>
        <template #description>
            {{ content.description }}
        </template>
        <template #action>
            <div class="flex items-center lg:flex-row flex-col  gap-4 mt-10">
                <a :href="useRuntimeConfig().public.app_user_url" target="_blank"
                    class="flex items-center gap-2 h-[50px] px-8 rounded-3xl bg-success-bold  text-white drop-shadow-md hover:drop-shadow-xl">
                {{ $t('try_free_now') }}</a>
                <a :href="useRuntimeConfig().public.app_user_url + '/page-builder'" target="_blank"
                    class="flex items-center gap-2 h-[50px] px-8 rounded-3xl  bg-white text-black drop-shadow-md hover:drop-shadow-xl">
                {{ $t('try_page_editor') }}</a>
            </div>
        </template>
        <template #image>
            <nuxt-img loading="lazy" src="/analytic-left.svg" class="md:block hidden" format="webp" alt="Create, manage and track all your QR Codes." />
        </template>
    </LayoutsSectionCardTemplate>
</template>
<script lang="ts" setup>
interface Content {
    locale: string,
    title: string,
    description: string,
}

const contentLocal: Array<Content> = [
    {
        locale: "en",
        title: "Create, manage and track all your QR Codes.",
        description: "Design beautiful QR codes your way. Add your own colors, logos and frames.",
    },
    {
        locale: "fr",
        title: "Créez, gérez et suivez tous vos codes QR.",
        description: "Concevez de beaux codes QR à votre façon. Ajoutez vos propres couleurs, logos et cadres.",
    },
    {
        locale: "de",
        title: "Erstellen, verwalten und verfolgen Sie alle Ihre QR-Codes.",
        description: "Entwerfen Sie schöne QR-Codes auf Ihre eigene Art und Weise. Fügen Sie Ihre eigenen Farben, Logos und Rahmen hinzu.",
    },
    {
        locale: "it",
        title: "Crea, gestisci e traccia tutti i tuoi codici QR.",
        description: "Progetta bellissimi codici QR a modo tuo. Aggiungi i tuoi colori, loghi e cornici.",
    },
    {
        locale: "es",
        title: "Crea, administra y rastrea todos tus códigos QR.",
        description: "Diseña hermosos códigos QR a tu manera. Agrega tus propios colores, logotipos y marcos.",
    },
    {
        locale: "nl",
        title: "Maak, beheer en volg al uw QR-codes.",
        description: "Ontwerp prachtige QR-codes op uw eigen manier. Voeg uw eigen kleuren, logo's en kaders toe.",
    },
    {
        locale: "ja",
        title: "すべてのQRコードを作成、管理、追跡してください。",
        description: "自分の好みに合わせて美しいQRコードをデザインしてください。自分の色、ロゴ、フレームを追加できます。",
    },
    {
        locale: "pt",
        title: "Crie, gerencie e rastreie todos os seus códigos QR.",
        description: "Projete belos códigos QR do seu jeito. Adicione suas próprias cores, logotipos e molduras.",
    },
    {
        locale: "vi",
        title: "Tạo, quản lý và theo dõi tất cả các mã QR của bạn.",
        description: "Thiết kế mã QR đẹp theo cách của bạn. Thêm màu sắc, logo và khung của riêng bạn.",
    },
    {
        locale: "zh",
        title: "创建、管理和跟踪您所有的QR码。",
        description: "以您的方式设计美丽的QR码。添加您自己的颜色、标志和框架。",
    }
]

const { locale } = useI18n();
const contentLocale = contentLocal.find(item => item.locale == locale.value)
const content = contentLocale ?? contentLocal[0]

</script>